import React from "react";

const Principles = () => {
  return (
    <div>
      <div>
        <h2>Rules for Life (But there are no rules!)</h2>
        <p>
          There are an infinite number of variables in life. Life is an
          n-dimensional equation to be solved. Below are some principles I live by to make sense of the chaos. This is a living breathing
          document that is subject to change as I walk through the journey that
          is life.{" "}
        </p>
        <ol>
          <li>High standards are habitual.</li>
          <ul>
            <li>
              High standards become second nature when consistently upheld.
            </li>
            <li>
              Small positive choices compound. How you present yourself, speak about yourself, and follow up on commitments to yourself and others will compound over time. Conversely, poor choices also compound. 
            </li>
            <li>
              Habitually help others and ask for help. Raising the bar is a
              team effort, and asking early prevents small problems from
              becoming big ones.
            </li>
          </ul>
          <li>Anything is possible. Truly.</li>
          <ul>
            <li>
              Your beliefs become your reality. As a founder, I'm consistently
              willing mere thoughts in my head into existence (e.g. my startup).
            </li>
            <li>
              My key observation from attending Harvard is that Harvard
              students are no smarter than the average student. They just believe anything is possible.
              For example, when I interviewed an MIT student, I asked him if he
              was familair with MUI/Next.js. He said no but he was sure he could learn it
              quickly. When I worked with a Vanderbilt grad, she would
              constantly tell me why something not possible instead of how it
              could be possible.
            </li>
            <li>
              I hate hate hate objections. Run through walls instead. 
            </li>
          </ul>

          <li>Work hard.</li>
          <ul>
            <li>
              Work ethic has gotten me very far in life. I respect people who work hard. I
              dislike complacent people and can't spend too much time around
              them. 
            </li>
            <li>
              Everytime I've put my head down, I've been rewarded with opportunity. For example, I
              never thought at 24 I would be invited by the Chancellor of
              Vanderbilt to speak at my alma mater.
            </li>
            <li>
              Preferably you work hard on something you are passionate about.
              It makes it working a lot easier and you will feel energized as
              you work more.
            </li>
          </ul>
        </ol>
      </div>
      <div>
        <h2>Software Engineering Principles</h2>
        <p>
          In the realm of software engineering, certain principles guide the
          creation of robust, maintainable, and efficient code. These principles
          serve as a foundation for good software design and development
          practices. Here are a few key principles I adhere to:
        </p>
        <ol>
          <li>
            Keep it simple. Avoid unnecessary complexity and over-engineering.
            Simple code is easier to understand, maintain, and debug.
          </li>
          <li>
            DRY - Don't repeat yourself. Make reusable components. Every piece
            of logic should have a single representation in the system.
          </li>

          <li>
            You aren't going to need it. - Don't add additional functionality
            until it is absolutely necessary.
          </li>
          <li>
            Readability - Write code that is easy to read and understand rather
            than trying to be clever and solve a problem in as few lines as
            possible. Another human will inevitably have to read your code,
            debug, and maintain your code so you are just causing more headaches
            for someone else down the line.
          </li>
        </ol>
      </div>
    </div>
  );
};
export default Principles;
